// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo__361ED","footer":"footer__1itDh","links":"links__QXZR-","media":"media__2Cx2f"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/Footer.scss
// module id = RaP0
// module chunks = 1